import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { getOssConfig } from '@/api/system/upload.js'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { guid } from '@/utils/ruoyi.js'

export default class UploadFileToOSS {
  /**
   * [constructor description]
   * @param  {[Array]} files [chooseImg选中的tempFilePaths、chooseVideo选中的rempFilePath]
   * @param  {[Object]} json  [success每上传成功一张调用 complete全部上传完成调用]
   * @return {[void]}       [description]
   */

  constructor(files, json) {
    if (!Array.isArray(files)) {
      throw new Error('Class UploadFileToOSS parameter must be an array')
    }
    if (!files || files.length === 0) {
      throw new Error('Files array cannot be empty')
    }
    console.log('files, json', files, json)
    this.data = []
    this.fn = json.success
    this.complete = json.finally || json.complete // 支持 finally 或 complete
    this.files = files
    this.fileLen = this.files.length
    this.curIndex = 0
    // notification.info({ message: '上传中' })
    this.upload()
  }

  async upload() {
    // 检查是否还有文件需要上传
    if (this.curIndex >= this.fileLen) {
      if (this.complete) {
        this.complete(this.data)
      }
      return
    }

    const token = storage.get(ACCESS_TOKEN)
    // 随机生成一个文件名，并且按照日期归类到二级目录下，否则很容易产生覆盖
    const dates = new Date()
    const year = dates.getFullYear()
    const month = dates.getMonth() + 1
    const date = dates.getDate()
    const nowDate = year + '-' + (month < 10 ? `0${month}` : month) + '-' + (date < 10 ? `0${date}` : date)
    const bmonth = month < 10 ? `0${month}` : month
    const bdate = date < 10 ? `0${date}` : date

    // 获取当前要上传的文件
    const currentFile = this.files[this.curIndex]
    if (!currentFile) {
      console.error('当前文件不存在，索引：', this.curIndex)
      this.curIndex++
      this.upload() // 继续下一个文件
      return
    }

    try {
      const res = await getOssConfig()
      const ossData = res.data
      if (!ossData) {
        throw new Error('获取OSS配置失败')
      }

      const form = new FormData()
      // 获取文件扩展名，支持多种方式
      let name = 'jpg' // 默认扩展名
      if (currentFile.type) {
        const typeParts = currentFile.type.split('/')
        if (typeParts.length > 1) {
          name = typeParts[1]
        }
      } else if (currentFile.name) {
        const nameParts = currentFile.name.split('.')
        if (nameParts.length > 1) {
          name = nameParts[nameParts.length - 1]
        }
      }
      const number = Date.now()
      // form.append('key', `${year}/${bmonth}/${bdate}/` + ossData.fileName + '.' + name)
      form.append('key', `admin/${year}${bmonth}/${year}${bmonth}${bdate}/` + number + '.' + name)
      form.append('policy', ossData.policy)
      form.append('OSSAccessKeyId', ossData.accessid)
      form.append('success_action_status', '200')
      form.append('signature', ossData.signature)
      form.append('file', currentFile)

      try {
        const response = await axios({
          url: ossData.uploadUrl,
          method: 'post',
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'multipart/form-data',
            'Content-Disposition': 'attachment;filename=' + encodeURIComponent(number)
          },
          data: form
        })

        console.log('上传响应', response)
        if (response.status === 200) {
          // let url = ossData.resultUrl + `/${year}/${bmonth}/${bdate}/` + ossData.fileName + '.' + name
          const url = ossData.uploadUrl + `admin/${year}${bmonth}/${year}${bmonth}${bdate}/` + number + '.' + name
          this.data.push({
            uid: guid(8, 10),
            status: 'done',
            name: number + '.' + name,
            halfUrl: `admin/${year}${bmonth}/${year}${bmonth}${bdate}/` + number + '.' + name,
            path: url,
            url: url,
            cover: ''
          })
          // 每上传成功一个文件，调用 success 回调
          if (this.fn) {
            this.fn(this.data)
          }
        } else {
          notification.error('上传失败，请重试')
        }
      } catch (error) {
        console.error('上传文件失败', error)
        notification.error('上传失败：' + (error.message || '未知错误'))
      } finally {
        // finally 不接受参数，移除 res 参数
        console.log('当前文件上传完成，索引：', this.curIndex)
        this.curIndex++ // 当前文件执行完上传后，开始上传下一张
        if (this.curIndex >= this.fileLen) { // 当文件传完时，停止调用
          if (this.complete) {
            this.complete(this.data)
          }
        } else { // 若文件还没有传完，则继续调用函数
          this.upload()
        }
      }
    } catch (error) {
      console.error('获取OSS配置失败', error)
      notification.error('获取上传配置失败：' + (error.message || '未知错误'))
      // 即使失败也要继续处理下一个文件，避免卡住
      this.curIndex++
      if (this.curIndex >= this.fileLen) {
        if (this.complete) {
          this.complete(this.data)
        }
      } else {
        this.upload()
      }
    }
  }
}
